// OrdersStatsCompact.tsx
import React from "react";

type Bucket = {
  total?: number;
  pending?: number;
  completed?: number;
  cancelled?: number;
};
type Stats = {
  today?: Bucket;
  lastMonth?: Bucket;
  allTime?: Bucket;
  timezone?: string;
};

const fmt = (n = 0) =>
  new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(n);

export default function OrdersStatsCompact({
  stats,
  value, // optional override for "today" (e.g., bookings count)
  label = "orders", // base noun: "orders" / "appointments"
  className = "",
  loading = false,
}: {
  stats?: Stats;
  value?: number;
  label?: string; // e.g., "orders" or "appointments"
  className?: string;
  loading?: boolean;
}) {
  const today = value ?? stats?.today?.total ?? 0;
  const lastMonth = stats?.lastMonth?.total ?? 0;
  const allTime = stats?.allTime?.total ?? 0;

  if (loading) {
    return (
      <div
        className={`w-80 h-6 rounded-full bg-white/20 dark:bg-white/10 animate-pulse ${className}`}
      />
    );
  }

  return (
    <p className={`text-textGray text-xs lg:text-sm ${className}`}>
      <strong className="font-semibold tabular-nums text-redlight">
        {fmt(today)}
      </strong>{" "}
      {label}
      <span className="mx-2 text-textGray">today •</span>
      <strong className="font-semibold tabular-nums">
        {fmt(lastMonth)}
      </strong>{" "}
      last month
      <span className="mx-2 text-textGray">today •</span>
      <strong className="font-semibold tabular-nums">
        {fmt(allTime)}
      </strong>{" "}
      all-time
    </p>
  );
}
